import {
	type CacheConfig,
	Environment,
	type GraphQLSingularResponse,
	type IEnvironment,
	Network,
	type RequestParameters,
	type Variables,
} from 'relay-runtime';

import { fg } from '@atlaskit/platform-feature-flags';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import { type AGGError, captureErrors, isUnauthenticated } from '@atlassian/relay-errors';
import { fetch } from '@atlassian/relay-fetch/multi-fetch';
import { fetchFn as legacyFetch } from '@atlassian/relay-network';
import { SSRQueryResponseCache } from '@atlassian/relay-query-responses';
import { subscribe } from '@atlassian/relay-subscription';
const getLoggingAndMetricsHelper = () => {
	return {
		logNonBreakingErrors: () => {},
		logError: () => {},
		logErrorRetry: () => {},
		logQueryFallbackToPost: () => {},
	};
};

/**
 * @deprecated use useRelayEnvironment() from react-relay to get this environment instead of using it directly
 */
export const __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__: IEnvironment =
	new Environment(
		getDefaultRelayEnvironmentConfig({
			network: Network.create(
				(request: RequestParameters, variables: Variables, cacheConfig: CacheConfig) => {
					// use new fetch if the feature flag is enabled
					if (
						fg('platform_environment_for_atlassian_studio') ||
						fg('relay_store_for_platform_packages_in_confluence')
					) {
						return fetch(request, variables, cacheConfig, {
							getLoggingAndMetricsHelper,
							withErrorHandling: (source: Promise<Response>) => source,
							validateResponse: (request: RequestParameters, response: GraphQLSingularResponse) => {
								const errors = 'errors' in response ? response.errors : undefined;
								if (errors != null) {
									const requestId = response?.extensions?.gateway?.request_id;

									captureErrors(errors as AGGError[], { operationName: request.name, requestId });

									if (isUnauthenticated(errors as AGGError[])) {
										return false;
									}
								}
								return true;
							},
							onInvalidResponse: () => {},
							queryResponseCache: new SSRQueryResponseCache({
								cacheName: 'relay-cache/v2/AGG',
								size: Infinity,
								ttl: Infinity,
							}),
							isServer: (globalThis as any).__SERVER__,
						});
					}

					// fallback to currnt fetch
					return legacyFetch(request, variables, cacheConfig);
				},
				subscribe,
			),
		}),
	);
